import { useMemo } from 'react';

export const useFooter = (rows) => {
  return useMemo(() => {
    if (!rows || rows.length === 0) {
      return null;
    }

    const totals = {
      vacation: 0,
      holiday: 0,
      earnedTime: 0,
      personal: 0,
      training: 0,
      bereavement: 0,
      unionBusiness: 0,
      departmentBusiness: 0,
      selfSick: 0,
      familySick: 0,
      leaveWithPay: 0,
      leaveWithoutPay: 0,
      swap: 0,
      injured: 0,
      academy: 0,
      openPosition: 0,
      ffcra: 0,
    };

    rows.forEach((row) => {
      Object.keys(totals).forEach((key) => {
        const value = parseFloat(row[key]) || 0;
        totals[key] += value;
      });
    });

    return [
      'Total',
      totals.vacation,
      totals.holiday,
      totals.earnedTime,
      totals.personal,
      totals.training,
      totals.bereavement,
      totals.unionBusiness,
      totals.departmentBusiness,
      totals.selfSick,
      totals.familySick,
      totals.leaveWithPay,
      totals.leaveWithoutPay,
      totals.swap,
      totals.injured,
      totals.academy,
      totals.openPosition,
      totals.ffcra,
    ];
  }, [rows]);
};
